export default {
  flexiblePath: {
    show: true,
    contentShow: true,
    currentPosition: 1
  }
}
